import { func, shape, string } from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'reactstrap';

import { withDocumentTitle } from '../generic/DocumentTitle';
import Titled from '../layout/Titled';
import { zmsAMMerchantShape } from '../prop-types';
import api from '../REST/api';
import update from '../REST/update';
import { COLORS } from '../utils/constants';
import { tapFlashSuccess } from '../utils/flash';
import MerchantForm from './MerchantForm';
import {
  getTransformedMerchant,
  transformForPatch,
  transformForRendering,
} from './transform-merchant-helpers';

function getIdFromRoute(match) {
  return Number.parseInt(match.params.id, 10);
}

function UpdateMerchant({ match, onSubmit, model, ...rest }) {
  const id = getIdFromRoute(match);
  const merchantName = model.name;
  return (
    <Titled
      title={`Edit - ${merchantName}`}
      actions={[
        <Link to="show" className="btn btn-secondary ml-2">
          Cancel
        </Link>,
        <Button color={COLORS.PRIMARY} className="ml-2" onClick={onSubmit}>
          Save
        </Button>,
      ]}
      sticky
    >
      <MerchantForm id={id} onSubmit={onSubmit} model={model} {...rest} />
    </Titled>
  );
}

UpdateMerchant.propTypes = {
  match: shape({ params: shape({ id: string.isRequired }).isRequired })
    .isRequired,
  onSubmit: func.isRequired,
  model: zmsAMMerchantShape.isRequired,
};

export default update({
  query: getTransformedMerchant,
  deriveQueryArgs: ({ match }) => ({
    id: getIdFromRoute(match),
  }),
  update({ match }, changedModel, oldModel) {
    const id = getIdFromRoute(match);

    return api
      .patchZMSAMMerchant({
        id,
        data: transformForPatch(changedModel, oldModel),
      })
      .then(transformForRendering)
      .then(tapFlashSuccess('Merchant update successful'));
  },
  form: withDocumentTitle(({ model }) => model.name)(UpdateMerchant),
  redirectTo: '/merchants/:id/show',
});
